export const DATES_TEXT = (fromDate: string, untilDate: string) =>
  fromDate === untilDate ? fromDate : `${fromDate} - ${untilDate}`;
